import {
  all,
  call,
  fork,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";

import {
  ADD_CANDIDATE,
  CLOSE_JOB,
  DELETE_CANDIDATE_ON_CANDIDATEPOOL,
  DELETE_MAPPED_JOB_CANDIDATE,
  EXTEND_JOB,
  GET_MAPPED_JOB_CANDIDATE_DETAIL,
  GET_MATCHED_CANDIDATE_DETAIL,
  GET_MATCHING_CANDIDATE,
  GET_MATCHING_JOB_BOARD_CANDIDATE,
  GET_SELECTED_JOB_DETAIL,
  GET_SIMILAR_JOB_DETAIL,
  GOOGLE_JOB_DETAILS,
  JOB_LISTING_SUGGESTIONS,
  JOB_STATUS,
  OTHER_JOB_DETAILS,
  POST_POPUP_DATA,
  SEND_CANDIDATE_INTEREST_REMINDER,
  SET_MAPPED_JOB_CANDIDATE_DETAIL,
  UPDATE_MAPPED_CANDIDATE,
  VIEW_JOB,
  GENERATE_MATCHING_SCORE,
  GET_DEFAULT_WEIGHTAGE,
  GET_CUSTOM_WEIGHTAGE,
  SAVE_CUSTOM_WEIGHTAGE,
  GET_FILTERED_JOB_BOARD_CANDIDATES,
  GET_CANDIDATE_FACETS,
  GENERATE_BULK_MATCHING_SCORE,
  GET_JOB_BASED_FACETS,
  BULK_MAP_CANDIDATES_TO_JOB,
} from "./actionTypes";
import {
  addCandidateFailure,
  addCandidateSuccess,
  candidateDeleteFailed,
  candidateDeleteSuccess,
  closeJobFailed,
  closeJobSuccess,
  deleteMappedCandidateFailed,
  deleteMappedCandidateSuccess,
  extendJobFailed,
  extendJobSuccess,
  getMappedCandidateJobFailed,
  getMappedCandidateJobSuccess,
  getMatchedCandidateDetailFailed,
  getMatchedCandidateDetailSuccess,
  getMatchingCandidateFailed,
  getMatchingCandidateSuccess,
  getMatchingJobBoardCandidateSuccess,
  getSimilarJobsDetailsFailed,
  getSimilarJobsDetailsSuccess,
  getSimilarSelectedJobsDetailsFailed,
  getSimilarSelectedJobsDetailsSuccess,
  getviewJobDetailsFailed,
  getviewJobDetailsSuccess,
  googleJobDetailsFailed,
  googleJobDetailsSuccess,
  jobStatusFailed,
  jobStatusSuccess,
  otherJobDetailsFailed,
  otherJobDetailsSuccess,
  postPopupDataFailed,
  postPopupDataSuccess,
  sendCandidateReminderFail,
  sendCandidateReminderSuccess,
  setMappedCandidateJobFailed,
  setMappedCandidateJobSuccess,
  suggestionApiFailed,
  suggestionApiSuccess,
  updateMappedCandidateFailed,
  updateMappedCandidateSuccess,
  getMappedCandidateJob,
  generateMatchingScoreSuccess,
  generateMatchingScoreError,
  getDefaultWeightageSuccess,
  getDefaultWeightageError,
  getCustomWeightageSuccess,
  getCustomWeightageError,
  saveCustomWeightageSuccess,
  saveCustomWeightageError,
  getCustomWeightage as getCustomWeightageAction,
  getFilteredJobPortalCandidatesSuccess,
  getFilteredJobPortalCandidatesError,
  getCandidateFacetsSuccess,
  getCandidateFacetsError,
  generateBulkMatchingScoreError,
  generateBulkMatchingScoreSuccess,
  getJobBasedFacetsSuccess,
  getJobBasedFacetsError,
  bulkMapCandidatesToJobError,
  bulkMapCandidatesToJobSuccess,
} from "./actions";

import {
  deleteApp,
  deleteCall2,
  getCall,
  getCandidateJobMap,
  postAddCandidate,
  postCallForJob,
  postCallMapping,
  postModalPopudata,
  getDefaultWeightage,
  getCustomWeightage,
  postCustomWeightage,
} from "../../../../../helpers/fakebackend_helper";

import * as urls from "../../../../../helpers/url_helper";

//restapi end point
import * as constClass from "../../../../../common/constant/constantURL";
import { get, post } from "../../../../../helpers/api_helper";
import { verifyData } from "../../../../../pages/Common/CommonFunctions/commonFunctions";
import axios from "axios";

function* getViewJobDetails({ payload: { viewJob } }) {
  try {
    let url;
    let data = JSON.parse(localStorage.getItem("authUser"));

    if (data.userType === "RECRUITER" || data.userType === "Recruiter") {
      url = `${constClass.REST_API_RECRUITER_GET_JOB_DATA}?id=${viewJob}`;
    } else {
      url = constClass.REST_API_GET_JOB_DATA + viewJob;
    }

    const responsJSON = yield call(postCallForJob, url);
    yield put(getviewJobDetailsSuccess(responsJSON));
  } catch (error) {
    yield put(getviewJobDetailsFailed(error));
  }
}

//get matching candidate
function* getMatchingCandidatesDetail({ payload: { matchingCandidate } }) {
  try {
    if (
      !matchingCandidate ||
      matchingCandidate.jobId === undefined ||
      matchingCandidate.jobId === null ||
      matchingCandidate.jobId === "" ||
      matchingCandidate.jobId === "undefined"
    ) {
      return;
    }

    let url = `${constClass.REST_API_GET_MATCHING_CANDIDATES}?jobId=${matchingCandidate.jobId}&pageNo=${matchingCandidate.page}&pageSize=10`;

    if (matchingCandidate.keyword && matchingCandidate.keyword !== "") {
      url += `&keyword=${encodeURIComponent(matchingCandidate.keyword)}`;
    }

    let responsJSON = yield call(get, url);
    yield put(getMatchingCandidateSuccess(responsJSON));
  } catch (error) {
    yield put(getMatchingCandidateFailed(error));
  }
}

function* getMatchingJobBoardCandidatesDetail({
  payload: { matchingCandidate },
}) {
  try {
    if (
      !matchingCandidate ||
      matchingCandidate.jobId === undefined ||
      matchingCandidate.jobId === null ||
      matchingCandidate.jobId === "" ||
      matchingCandidate.jobId === "undefined"
    ) {
      console.warn(
        "getMatchingJobBoardCandidatesDetail: invalid jobId",
        matchingCandidate,
      );
      return;
    }

    // Build base URL - ensure jobId is always included
    let url = `${constClass.REST_API_GET_JOBPORTAL_CANDIDATES}jobId=${matchingCandidate.jobId}&pageNo=${matchingCandidate.page !== undefined ? matchingCandidate.page : 0}&pageSize=${matchingCandidate.pageSize !== undefined ? matchingCandidate.pageSize : 10}`;

    console.log("getMatchingJobBoardCandidatesDetail - Initial URL:", url);

    // Add keyword if present
    if (matchingCandidate.keyword && matchingCandidate.keyword !== "") {
      url += `&keyword=${encodeURIComponent(matchingCandidate.keyword)}`;
    }

    // Add filters if present (for filtered search)
    if (
      matchingCandidate.jobProfiles &&
      matchingCandidate.jobProfiles.length > 0
    ) {
      matchingCandidate.jobProfiles.forEach((profile) => {
        url += `&jobProfiles=${encodeURIComponent(profile)}`;
      });
    }

    if (matchingCandidate.skills && matchingCandidate.skills.length > 0) {
      matchingCandidate.skills.forEach((skill) => {
        url += `&skills=${encodeURIComponent(skill)}`;
      });
    }

    if (matchingCandidate.locations && matchingCandidate.locations.length > 0) {
      matchingCandidate.locations.forEach((location) => {
        url += `&locations=${encodeURIComponent(location)}`;
      });
    }

    if (
      matchingCandidate.minExperience !== null &&
      matchingCandidate.minExperience !== undefined
    ) {
      url += `&minExperience=${matchingCandidate.minExperience}`;
    }

    if (
      matchingCandidate.maxExperience !== null &&
      matchingCandidate.maxExperience !== undefined
    ) {
      url += `&maxExperience=${matchingCandidate.maxExperience}`;
    }

    if (matchingCandidate.crossFilterLogic) {
      url += `&crossFilterLogic=${matchingCandidate.crossFilterLogic}`;
    }

    if (matchingCandidate.skillsLogic) {
      url += `&skillsLogic=${matchingCandidate.skillsLogic}`;
    }

    console.log("getMatchingJobBoardCandidatesDetail - Final URL:", url);

    let responsJSON = yield call(get, url);
    console.log("getMatchingJobBoardCandidatesDetail - Response:", responsJSON);
    yield put(getMatchingJobBoardCandidateSuccess(responsJSON));
  } catch (error) {
    console.error("getMatchingJobBoardCandidatesDetail - Error:", error);
    yield put(getMatchingCandidateFailed(error));
  }
}

// Get candidate facets (filter options)
function* getCandidateFacetsHandler({ payload: { jobId } }) {
  try {
    if (!jobId || jobId === "undefined" || jobId === "null") {
      console.warn(
        "getCandidateFacetsHandler: invalid jobId, skipping API call",
      );
      return;
    }

    // CORRECTED: Build URL properly - REST_API_GET_JOBPORTAL_CANDIDATES already has '?'
    // So we need to use '&' before 'facets' parameter
    let url = `${constClass.REST_API_GET_JOBPORTAL_CANDIDATES.replace("?", "/")}facets?jobId=${jobId}`;
    console.log("getCandidateFacetsHandler - URL:", url);

    let responsJSON = yield call(get, url);
    console.log("getCandidateFacetsHandler - Response:", responsJSON);
    yield put(getCandidateFacetsSuccess(responsJSON));
  } catch (error) {
    console.error("getCandidateFacetsHandler - Error:", error);
    yield put(getCandidateFacetsError(error));
  }
}

// Get Job-Based Facets
function* getJobBasedFacetsHandler({ payload: { jobId } }) {
  try {
    if (!jobId || jobId === "undefined" || jobId === "null") {
      console.warn("getJobBasedFacetsHandler: invalid jobId");
      return;
    }

    let url = `${constClass.REST_API_GET_JOBPORTAL_CANDIDATES.replace("?", "/")}job-facets?jobId=${jobId}`;

    let responsJSON = yield call(get, url);
    yield put(getJobBasedFacetsSuccess(responsJSON));
  } catch (error) {
    console.error("getJobBasedFacetsHandler - Error:", error);
    yield put(getJobBasedFacetsError(error));
  }
}

// Bulk Generate Matching Score
function* generateBulkMatchingScoreHandler({
  payload: { jobId, candidateIds },
}) {
  try {
    if (!jobId || !candidateIds || candidateIds.length === 0) {
      console.warn(
        "generateBulkMatchingScoreHandler: invalid jobId or candidateIds",
      );
      yield put(generateBulkMatchingScoreError("Invalid job or candidates"));
      return;
    }

    const url = `searchandmatch/match/bulk`;

    const response = yield call(post, url, {
      jobId,
      candidateIds,
    });

    yield put(generateBulkMatchingScoreSuccess(response));
  } catch (error) {
    console.error("generateBulkMatchingScoreHandler - Error:", error);
    yield put(
      generateBulkMatchingScoreError(
        error?.message || "Failed to generate scores",
      ),
    );
  }
}

// Bulk Map Candidates to Job
function* bulkMapCandidatesToJobHandler({ payload: { jobId, candidates } }) {
  try {
    if (!jobId || !candidates || candidates.length === 0) {
      console.warn(
        "bulkMapCandidatesToJobHandler: invalid jobId or candidates",
      );

      yield put(bulkMapCandidatesToJobError("Invalid job or candidates"));

      return;
    }

    const url = "recruitment/bulk";

    const response = yield call(post, url, {
      jobId,
      candidates,
    });

    yield put(bulkMapCandidatesToJobSuccess(response));

    // Refresh mapped candidate list after bulk mapping
    yield put(
      getMappedCandidateJob({
        mappedCandidate: jobId,
        mappedCandidateType: "ALL",
        page: 0,
        pageSize: 10,
        keyboard: null,
        sort: null,
      }),
    );
  } catch (error) {
    console.error("bulkMapCandidatesToJobHandler - Error:", error);

    yield put(
      bulkMapCandidatesToJobError(error?.message || "Failed to map candidates"),
    );
  }
}

// Get filtered job portal candidates
function* getFilteredJobPortalCandidatesHandler({ payload: { filters } }) {
  try {
    if (
      !filters ||
      !filters.jobId ||
      filters.jobId === "undefined" ||
      filters.jobId === "null"
    ) {
      console.warn(
        "getFilteredJobPortalCandidatesHandler: invalid jobId, skipping API call",
      );
      return;
    }

    // Build query string
    let url = `${constClass.REST_API_GET_JOBPORTAL_CANDIDATES}jobId=${filters.jobId}&pageNo=${filters.pageNo || 0}&pageSize=${filters.pageSize || 10}`;

    // Add filters
    if (filters.jobProfiles && filters.jobProfiles.length > 0) {
      filters.jobProfiles.forEach((profile) => {
        url += `&jobProfiles=${encodeURIComponent(profile)}`;
      });
    }

    if (filters.skills && filters.skills.length > 0) {
      filters.skills.forEach((skill) => {
        url += `&skills=${encodeURIComponent(skill)}`;
      });
    }

    if (filters.locations && filters.locations.length > 0) {
      filters.locations.forEach((location) => {
        url += `&locations=${encodeURIComponent(location)}`;
      });
    }

    if (filters.minExperience !== null && filters.minExperience !== undefined) {
      url += `&minExperience=${filters.minExperience}`;
    }

    if (filters.maxExperience !== null && filters.maxExperience !== undefined) {
      url += `&maxExperience=${filters.maxExperience}`;
    }

    if (filters.crossFilterLogic) {
      url += `&crossFilterLogic=${filters.crossFilterLogic}`;
    }

    if (filters.skillsLogic) {
      url += `&skillsLogic=${filters.skillsLogic}`;
    }

    if (filters.keyword && filters.keyword !== "") {
      url += `&keyword=${encodeURIComponent(filters.keyword)}`;
    }

    let responsJSON = yield call(get, url);
    yield put(getFilteredJobPortalCandidatesSuccess(responsJSON));
  } catch (error) {
    yield put(getFilteredJobPortalCandidatesError(error));
  }
}

//get matched candidate details
function* getMatchedCandidateDetail({ payload: { matchedCandidateDetail } }) {
  try {
    console.log("matchedCandidateDetail", matchedCandidateDetail);
    let url =
      constClass.REST_API_SIMILAR_CANDIDATE_DETAIL + matchedCandidateDetail;
    let responsJSON = yield call(postCallForJob, url);
    yield put(getMatchedCandidateDetailSuccess(responsJSON));
  } catch (error) {
    yield put(getMatchedCandidateDetailFailed(error));
  }
}

//get similar jobs
function* getSimilarJobsDetail({ payload: { similarJob, page } }) {
  try {
    let url;
    let id = encodeURIComponent(similarJob);
    url =
      "searchandmatch/match?currentDocumentId=" +
      id +
      "&page=" +
      page +
      "&pageSize=10&matchDocumentType=JD&currentDocumentType=JD&matchPublicCandidates=false";
    let responsJSON = yield call(getCall, url);
    yield put(getSimilarJobsDetailsSuccess(responsJSON));
  } catch (error) {
    yield put(getSimilarJobsDetailsFailed(error));
  }
}

//get selected similar job detail
function* getSimilarSelectedJobsDetail({ payload: { selectedJob } }) {
  try {
    let url = constClass.REST_API_JOB_DETAIL + selectedJob.jobId;
    let responsJSON = yield call(getCall, url);
    yield put(getSimilarSelectedJobsDetailsSuccess(responsJSON));
  } catch (error) {
    yield put(getSimilarSelectedJobsDetailsFailed(error));
  }
}

//get mapped candidate and job
function* fetchMappedCandidateJob({
  payload: {
    mappedCandidate,
    mappedCandidateType,
    page,
    pageSize,
    keyboard,
    sort,
  },
}) {
  try {
    // safely extract jobId whether it's a string or object
    const jobId =
      mappedCandidate !== null &&
      mappedCandidate !== undefined &&
      typeof mappedCandidate === "object"
        ? mappedCandidate?.jobId
        : mappedCandidate;

    // skip call if jobId is invalid
    if (!jobId || jobId === "undefined" || jobId === "null") {
      console.warn("fetchMappedCandidateJob: invalid jobId, skipping API call");
      return;
    }

    let url = `recruitment?jobId=${jobId}&stage=${mappedCandidateType}&page=${page}&pageSize=${pageSize}`;
    if (sort !== undefined && sort !== null && sort !== "") {
      url = url + encodeURI(`${sort}`);
    }
    if (keyboard !== undefined && keyboard !== null && keyboard !== "") {
      url = url + `${keyboard}`;
    }
    let responsJSON = yield call(postCallForJob, url);
    yield put(getMappedCandidateJobSuccess(responsJSON));
  } catch (error) {
    yield put(getMappedCandidateJobFailed(error));
  }
}

//delete mapped candidate and job
function* deleteMappedCandidateJob({ payload: { deleteMappedCandidate } }) {
  try {
    let url = `candidate?candidateId=${deleteMappedCandidate.candidateId}&jobId=${deleteMappedCandidate.jobId}`;
    yield call(deleteApp, url);

    yield put(
      deleteMappedCandidateSuccess("Candidate has been removed successfully."),
    );
  } catch (error) {
    yield put(deleteMappedCandidateFailed(error));
  }
}
//delete mapped candidate and job
function* setMappedCandidate({ payload: { setMappedCandidate } }) {
  try {
    let data = JSON.parse(localStorage.getItem("authUser"));

    // Both ORG and RECRUITER use the same endpoint: /recruitment
    const baseUrl = constClass.REST_API_SET_JOB_CANDIDATE_MAPPING; // must be "recruitment"

    const url =
      baseUrl +
      `?jobId=${setMappedCandidate.jobId}&candidateId=${setMappedCandidate.candidateId}&matchingScore=${setMappedCandidate.matchingScore === undefined ? "0.0" : setMappedCandidate.matchingScore}&source=${setMappedCandidate.source !== undefined && setMappedCandidate.source !== null ? setMappedCandidate.source : "ATS"}`;

    yield call(postCallMapping, url);

    // After mapping, ensure candidate is at SCREEN stage (not Interview)
    // The generate_matching_score endpoint may auto-map at Interview stage
    if (data.userType !== "RECRUITER") {
      try {
        const mappingCheckUrl = `recruitment?jobId=${setMappedCandidate.jobId}&candidateId=${setMappedCandidate.candidateId}`;
        const current = yield call(getCall, mappingCheckUrl);
        if (current?.status === "INTERVIEW") {
          yield call(post, constClass.REST_API_REJECT_CANDIDATE, {
            candidateId: setMappedCandidate.candidateId,
            jobId: setMappedCandidate.jobId,
            stage: "SCREEN",
          });
        }
      } catch (stageErr) {
        console.warn("Stage correction check failed", stageErr);
      }
    }

    // success message
    yield put(setMappedCandidateJobSuccess("Candidate mapped successfully"));

    // Re-fetch the candidate list so the UI refreshes immediately
    yield put(
      getMappedCandidateJob({
        mappedCandidate: setMappedCandidate.jobId,
        mappedCandidateType: "ALL",
        page: 0,
        pageSize: 10,
        keyboard: null,
        sort: null,
      }),
    );
  } catch (error) {
    yield put(setMappedCandidateJobFailed(error));
  }
}

//update mapped candidate status
function* updateMappedCandidate({ payload: { updateMappedCandidate } }) {
  try {
    let url;
    url = constClass.REST_API_UPDATE_JOB_MAPPED_CANDIDATE;
    let responsJSON = yield call(
      getCandidateJobMap,
      url,
      updateMappedCandidate,
    );

    yield put(updateMappedCandidateSuccess(responsJSON));
  } catch (error) {
    yield put(updateMappedCandidateFailed(error));
  }
}

function* closeJobHandler(data) {
  try {
    let url = constClass.REST_API_CLOSE_JOB + data.payload.jobId;
    let responseJSON = yield call(getCall, url);
    yield put(closeJobSuccess(responseJSON));
  } catch (error) {
    yield put(closeJobFailed(error));
  }
}

function* extendJobHandler(data) {
  try {
    let url =
      constClass.REST_API_EXTEND_JOB +
      `${data.payload.closingDate}&jobId=${data.payload.jobId}`;
    let responseJSON = yield call(getCall, url);
    yield put(extendJobSuccess(responseJSON));
  } catch (error) {
    yield put(extendJobFailed(error));
  }
}

function* otherJobDetailsHandler(id) {
  try {
    let url = constClass.REST_API_OTHER_JOB_DETAILS + id.payload;
    let responseJSON = yield call(getCall, url);
    yield put(otherJobDetailsSuccess(responseJSON));
  } catch (error) {
    yield put(otherJobDetailsFailed(error));
  }
}

function* googleJobsHandler(id) {
  try {
    let url = constClass.REST_API_GOOGLE_JOB_DETAILS + id.payload;
    let responseJSON = yield call(getCall, url);
    yield put(googleJobDetailsSuccess(responseJSON));
  } catch (error) {
    yield put(googleJobDetailsFailed(error));
  }
}

function* addCandidateHandler(details) {
  try {
    let url = constClass.REST_API_ADD_CANDIDATE;
    let responseJSON = yield call(postAddCandidate, url, details.payload);

    yield put(addCandidateSuccess(responseJSON));
  } catch (error) {
    yield put(addCandidateFailure(error));
  }
}

function* sendCandidateReminderHandler(data) {
  try {
    let url = constClass.REST_API_SEND_CANDIDATE_REMINDER;
    if (data.payload !== undefined && data.payload !== null) {
      const candidateId = data.payload?.candidateId;
      const jobId = data.payload?.jobId;

      if (!candidateId || !jobId) {
        yield put(sendCandidateReminderFail("Missing candidateId or jobId"));
        return;
      }
      url = url + `?candidateId=${candidateId}&jobId=${jobId}`;
    }
    let responseJson = yield call(getCall, url);
    yield put(sendCandidateReminderSuccess(responseJson));
  } catch (error) {
    yield put(sendCandidateReminderFail(error));
  }
}

function* suggestionWatcher(details) {
  try {
    let url;
    if (details.payload.column === "jobProfile") {
      url = constClass.REST_API_JOB_JOBPROFILE_SUGGESTION + details.payload.url;
    } else {
      url = constClass.REST_API_JOB_LOCATION_SUGGESTION + details.payload.url;
    }
    let responseJSON = yield call(getCall, url);
    yield put(suggestionApiSuccess(responseJSON));
  } catch (error) {
    yield put(suggestionApiFailed(error));
  }
}

function* jobStatusWatcher(details) {
  try {
    let responseJSON = yield call(
      getCall,
      constClass.REST_API_GET_JOB_ACTIVE + details.payload,
    );
    yield put(jobStatusSuccess(responseJSON));
  } catch (error) {
    yield put(jobStatusFailed(error));
  }
}

function* postpopupDataHandler(details) {
  try {
    let responseJSON = yield call(
      postModalPopudata,
      constClass.REST_API_POST_MODAL_POPUP,
      details.payload,
    );
    yield put(postPopupDataSuccess(responseJSON));
  } catch (error) {
    yield put(postPopupDataFailed(error));
  }
}

function* deleteCandidateHandler(data) {
  try {
    yield call(
      deleteCall2,
      constClass.REST_DELETE_CANDIDATE + `?candidateId=${data.payload}`,
    );
    yield put(candidateDeleteSuccess("Candidate has been deleted sucessfully"));
  } catch (error) {
    console.log(error);
    yield put(candidateDeleteFailed(error));
  }
}

// triggers async score calculation for a job portal candidate
function* generateMatchingScoreHandler({ payload }) {
  try {
    let url = `searchandmatch/match/calculate?jobId=${payload.jobId}&candidateId=${payload.candidateId}`;
    const response = yield call(post, url);
    yield put(
      generateMatchingScoreSuccess(response?.message || "Score generated"),
    );
  } catch (error) {
    yield put(
      generateMatchingScoreError(error?.message || "Score generation failed"),
    );
  }
}

function* getDefaultWeightageHandler() {
  try {
    const response = yield call(
      getDefaultWeightage,
      urls.GET_DEFAULT_WEIGHTAGE,
    );
    yield put(getDefaultWeightageSuccess(response?.weightages));
  } catch (error) {
    yield put(getDefaultWeightageError(error));
  }
}

function* getCustomWeightageHandler({ payload: jobId }) {
  try {
    const url = `${urls.GET_CUSTOM_WEIGHTAGE}?jobId=${jobId}`;
    const response = yield call(getCustomWeightage, url);
    yield put(getCustomWeightageSuccess(response?.weightages));
  } catch (error) {
    yield put(getCustomWeightageError(error));
  }
}

function* saveCustomWeightageHandler({ payload }) {
  try {
    const response = yield call(
      postCustomWeightage,
      urls.POST_CUSTOM_WEIGHTAGE,
      payload,
    );
    yield put(saveCustomWeightageSuccess(response?.message));
    yield put(getCustomWeightageAction(payload.jobId));
  } catch (error) {
    yield put(saveCustomWeightageError(error));
  }
}

export function* watchViewCandidate() {
  yield takeEvery(VIEW_JOB, getViewJobDetails);
  yield takeEvery(GET_MATCHING_CANDIDATE, getMatchingCandidatesDetail);
  yield takeEvery(
    GET_MATCHING_JOB_BOARD_CANDIDATE,
    getMatchingJobBoardCandidatesDetail,
  );
  yield takeEvery(GET_MATCHED_CANDIDATE_DETAIL, getMatchedCandidateDetail);
  yield takeEvery(GET_SIMILAR_JOB_DETAIL, getSimilarJobsDetail);
  yield takeEvery(GET_SELECTED_JOB_DETAIL, getSimilarSelectedJobsDetail);
  yield takeEvery(GET_MAPPED_JOB_CANDIDATE_DETAIL, fetchMappedCandidateJob);
  yield takeEvery(DELETE_MAPPED_JOB_CANDIDATE, deleteMappedCandidateJob);
  yield takeEvery(SET_MAPPED_JOB_CANDIDATE_DETAIL, setMappedCandidate);
  yield takeEvery(UPDATE_MAPPED_CANDIDATE, updateMappedCandidate);
  yield takeEvery(CLOSE_JOB, closeJobHandler);
  yield takeEvery(EXTEND_JOB, extendJobHandler);
  yield takeEvery(OTHER_JOB_DETAILS, otherJobDetailsHandler);
  yield takeEvery(GOOGLE_JOB_DETAILS, googleJobsHandler);
  yield takeEvery(ADD_CANDIDATE, addCandidateHandler);
  yield takeLatest(JOB_LISTING_SUGGESTIONS, suggestionWatcher);
  yield takeLatest(JOB_STATUS, jobStatusWatcher);
  yield takeLatest(POST_POPUP_DATA, postpopupDataHandler);
  yield takeLatest(
    SEND_CANDIDATE_INTEREST_REMINDER,
    sendCandidateReminderHandler,
  );
  yield takeLatest(DELETE_CANDIDATE_ON_CANDIDATEPOOL, deleteCandidateHandler);
  yield takeEvery(GENERATE_MATCHING_SCORE, generateMatchingScoreHandler);
  yield takeLatest(GET_DEFAULT_WEIGHTAGE, getDefaultWeightageHandler);
  yield takeLatest(GET_CUSTOM_WEIGHTAGE, getCustomWeightageHandler);
  yield takeLatest(SAVE_CUSTOM_WEIGHTAGE, saveCustomWeightageHandler);
  yield takeEvery(GET_CANDIDATE_FACETS, getCandidateFacetsHandler);
  yield takeEvery(
    GET_FILTERED_JOB_BOARD_CANDIDATES,
    getFilteredJobPortalCandidatesHandler,
  );
  yield takeEvery(GET_JOB_BASED_FACETS, getJobBasedFacetsHandler);
  yield takeEvery(
    GENERATE_BULK_MATCHING_SCORE,
    generateBulkMatchingScoreHandler,
  );
  yield takeEvery(BULK_MAP_CANDIDATES_TO_JOB, bulkMapCandidatesToJobHandler);
}
function* viewJobSaga() {
  yield all([fork(watchViewCandidate)]);
}

export default viewJobSaga;
